import type {
  InstrumentResolveUiState,
  PendingConnectorRequired,
  PendingMarketDataConsent,
  PendingMarketDataSourceChoice,
  PendingQuoteVariantChoice,
} from "../hooks/useInstrumentResolve";
import type { MarketDataAssetClassRequiredBody } from "../types/instruments";

export type ExecutionCandlesResolveGateInput = {
  state: InstrumentResolveUiState;
  pendingMarketDataSourceChoice: PendingMarketDataSourceChoice | null;
  pendingQuoteVariantChoice: PendingQuoteVariantChoice | null;
  pendingConsent: PendingMarketDataConsent | null;
  pendingConnectorRequired: PendingConnectorRequired | null;
  pendingAssetClassPayload: MarketDataAssetClassRequiredBody | null;
};

/** True while resolve modals must finish before OHLC fetch (Layer A only — not connector disconnect). */
export function isExecutionCandlesResolveGateBlocking(
  input: ExecutionCandlesResolveGateInput
): boolean {
  if (input.pendingQuoteVariantChoice) return true;
  if (input.pendingAssetClassPayload) return true;

  const { state } = input;
  if (state.kind === "loading") return true;

  // Consent, OHLC source choice, and connector disconnect use inline notices / candles 422.
  return false;
}

/** Production Trade Review: one candles fetch only after resolve is ready. */
export function canFetchProductionExecutionCandles(
  input: ExecutionCandlesResolveGateInput
): boolean {
  return !isExecutionCandlesResolveGateBlocking(input);
}
